import { AxiosRequestConfig } from 'axios';

import { ACCESS_TOKEN_KEY, ACCESS_USERID_KEY } from '@/constant/config';
import { request } from '@/utils/request';
import Storage from '@/utils/Storage';
export const getBalance = (config: AxiosRequestConfig) => {
  return request(
    {
      url: '/gamer/flush_balance',
      ...config
    },
    {
      isGetDataDirectly: true,
      skipErrorHandle: true
    }
  );
};

export const getBalanceInfo = (config: AxiosRequestConfig) => {
  return request(
    {
      url: '/gamer/get_balance_h5',
      ...config
    },
    {
      isGetDataDirectly: true,
      skipErrorHandle: true
    }
  );
};

export const getUserPhone = (data: { p_userid: number; p_gameid: 3 }) => {
  return request({
    url: '/db/qpgameuserdb.gsp_gp_qryuserinfo',
    method: 'post',
    data
  });
};

export const fetchIpaAward = () => {
  const p_userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/db/DBMonitor.gsp_gr_fetchawardfrom_openH5_ios_super',
    method: 'post',
    data: { p_userid }
  });
};

export const savePPgameSound = state => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  return request({
    url: '/gamer/save_ppgame_sound',
    method: 'post',
    data: { userid, token, flag: state ? 1 : 0 }
  });
};
